import Blue from "~/core";

new Blue({
	name: 'Right Rail',
	selector: ".js-rail-retach",
	setup(rail) {
	    this.$retach(rail, {
            destination: '.js-rail-destination', 
            mediaQuery: 992,
            movedClass: 'is-moved',
            moveMethod: 'append', 
            // wrapper: 'quote',
            // wrapperClass: 'my-wrapper',
            // callback_move() {
            //     this.style.fontSize = '2rem'
            // },
            // callback_back() {
            //     this.style.fontSize = ''
            // }
        })
	}
});

new Blue({
	name: 'Nav Secondary',
	selector: ".js-nav-secondary-retach",
	setup(rail) {
	    this.$retach(rail, {
            destination: '.js-nav-secondary-destination', 
            mediaQuery: 992,
            movedClass: 'is-moved',
            moveMethod: 'append', 
            // wrapper: 'quote',
            // wrapperClass: 'my-wrapper',
            // callback_move() {
            //     this.style.fontSize = '2rem'
            // },
            // callback_back() {
            //     this.style.fontSize = ''
            // }
        })
	}
});
